import React from 'react';

import { formatNumberWithCommas, parseNumberFormCommas } from '@pkgtour-workspace/common/dist/util/formatter';

import { hookFormFieldHoc, HookFormFieldCoreProps } from '../field.hoc';

export interface InputNumberWithCommaFieldProps extends HookFormFieldCoreProps {
  placeholder?: string;
}

const InputNumberWithCommaField: React.FC<InputNumberWithCommaFieldProps> = ({
  maxLength: _maxLength,
  minLength: _minLength,
  field,
  className,
  placeholder,
}) => {
  const maxLength = typeof _maxLength === 'object' ? _maxLength.value : _maxLength;
  const minLength = typeof _minLength === 'object' ? _minLength.value : _minLength;

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const currentValue = parseNumberFormCommas(e.target.value || '0');

    if (isNaN(currentValue)) {
      return;
    }
    const value = formatNumberWithCommas(currentValue);
    field?.onChange(value);
  };

  return (
    <input
      className={className}
      {...field}
      placeholder={placeholder}
      value={field?.value || ''}
      type="text"
      maxLength={maxLength}
      minLength={minLength}
      onChange={handleChange}
    />
  );
};

export default hookFormFieldHoc(InputNumberWithCommaField);
